
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component({
  name: "TheBottomTab"
})
export default class TheBottomTab extends Vue {
  routeName: string = "Home";
  activePage(routeName: string) {
    return this.routeName === routeName
      ? "router-link-exact-active router-link-active"
      : "";
  }
  onClick(path: string) {
    this.$router.push({ path });
  }
  @Watch("$route", { immediate: true, deep: true })
  onRouteChange(to: any, from: any) {
    this.routeName = to.name;
  }
}
